import { FC } from "react";

export const Appointments: FC = () => {
    return(
        <h1>Appointment</h1>
    );
}
